<template>
<el-dialog style="padding-bottom:10px;" title="Bill List" :visible.sync="modal" top="8vh" @close="() => this.search = ''">
    <div class="mb-2 mt-n8">
        <el-input prefix-icon="el-icon-search" placeholder="Search" v-model="search" clearable></el-input>
    </div>
    <template #title>
        <span v-if="batchId" class="white--text">Batch ID: <strong>{{ batchId }}</strong></span><br>
        <el-tag class="mr-1" effect="dark" type="success">Success: {{ totalSuccess }}</el-tag>
        <el-tag effect="dark" type="danger">Error: {{ totalError }}</el-tag>
    </template>
    <div class="pb-5">
        <e-table :headers="headers" :data="items" :total="items.length" :search="search" :height="window.height - 300" :loading="loading">
            <template #footer>
                <v-export-table text="Export" :tableColumns="exportColumns" :tableData="items" :filename="`Extensiv_LOG_STATUS_${batchId}-${Date.now()}`" :filesheet="`status`"></v-export-table>
            </template>
        </e-table>
    </div>
</el-dialog>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import * as type from '../../../store/types';
export default {
    data: () => ({
        modal: false,
        search: '',
        batchId: '',
        totalSuccess: '',
        totalError: '',
        headers: [{
                text: 'PO #',
                value: 'extensivPoNumber',
                width: "140",
                sortable: true
            },
            {
                text: 'Vendor',
                value: 'vendorName',
                sortable: true
            },
            {
                text: 'Warehouse',
                value: 'warehouseName',
                sortable: true
            },
            {
                text: 'SKU',
                value: 'vendorSku',
                sortable: true
            },
            {
                text: 'Quantity',
                value: 'quantity',
                width: "110",
                sortable: true
            },
            {
                text: 'Unit Cost',
                value: 'unitCost',
                width: "120",
                sortable: true
            },
            {
                text: 'Status',
                value: 'status',
                width: "140",
                sortable: true
            },
            {
                text: 'Error',
                value: 'lastError',
                sortable: true
            }
        ],
        exportColumns: [
            { label: 'Batch ID', field: 'batchId' },
            { label: 'PO #', field: 'extensivPoNumber' },
            { label: 'Vendor', field: 'vendorName' },
            { label: 'Warehouse', field: 'warehouseName' },
            { label: 'SKU', field: 'vendorSku' },
            { label: 'Quantity', field: 'quantity' },
            { label: 'Unit Cost', field: 'unitCost' },
            { label: 'Status', field: 'status' },
            { label: 'Error', field: 'lastError' }
        ]
    }),
    computed: {
        ...mapGetters({
            items: 'extensivlogs/itemsByBatchId',
            loading: 'extensivlogs/loading2',
        }),
    },
    methods: {
        ...mapActions({
            loadExtensivLogsByBatchId: `extensivlogs/${type.Extensiv_GET_LOGS_BY_BATCHID}`,
        }),
        viewBillsList(batchId) {
            this.totalSuccess = 0
            this.totalError = 0
            this.modal = true
            this.batchId = batchId;
            this.loadExtensivLogsByBatchId(batchId)
                .then(data => {
                    const normalized = data || [];
                    this.totalSuccess = normalized.filter(item => (item.status || '').toUpperCase() !== 'ERROR').length;
                    this.totalError = normalized.filter(item => (item.status || '').toUpperCase() === 'ERROR').length;
                })
        }
    }
}
</script>
